module.exports = __webpack_public_path__ + "img/20191211163714360截图20191211162301427.467b976c.jpg";